<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-envelope"></i> {{ "TITLE.RECIPIENTS" | translate }}
    </h4>
    <div class="text-right">
      <button class="btn btn-outline-success mt-2 mb-1"
              type="button" (click)="addRow()">+ {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="notifyPostOperationForm">
      <div formArrayName="arrayRecipients">
        <div class="form-group row" *ngFor="let group of arrayRecipients.controls; let index= index"
             [formGroupName]="index">
          <label class="col-md-3"
                 for="recipientInput{{index}}"><b>{{thereIsUniqueRow ? ("LABEL.RECIPIENT" | translate) + ':' : ("LABEL.RECIPIENT" | translate) + ' ' + (index + 1) + ':'}}</b></label>
          <div class="{{thereIsUniqueRow?'col-md-9':'col-md-8'}}">
            <input type="text"
                   id="recipientInput{{index}}"
                   class="form-control"
                   placeholder="Ejem.: ruc_20543237435@v2.midomicilio.pe"
                   formControlName="address">
          </div>
          <div class="col-md-1" *ngIf="!thereIsUniqueRow">
            <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteRow(index)"></i>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="subject" class="col-md-3 col-form-label"><b>{{ "LABEL.SUBJECT" | translate }}:</b></label>
        <div class="col-md-9">
          <input type="text"
                 id="subject"
                 class="form-control"
                 placeholder="Ingrese asunto"
                 formControlName="subject"
                 [(ngModel)]="sieemailReceived.subject">
        </div>
      </div>
      <div class="form-group row">
        <label for="subject" class="col-md-3 col-form-label"><b>{{ "LABEL.NOTIFICATION-CONTENT" | translate }}
          :</b></label>
        <div class="col-md-9">
          <quill-editor [styles]="{height: '200px'}"
                        [(ngModel)]="sieemailReceived.body"
                        formControlName="body">
          </quill-editor>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
